export type RegistrationConsents = {
  termsAccepted: boolean;
  kvkkRead: boolean;
  marketingAccepted: boolean;
};

export type CheckoutConsents = {
  preInformationAccepted: boolean;
  distanceSalesAccepted: boolean;
  returnPolicyAccepted: boolean;
};

export type StoredRegistrationConsents = {
  termsAcceptedAt: string;
  kvkkReadAt: string;
  marketingAccepted: boolean;
  marketingAcceptedAt?: string;
};

export type StoredCheckoutConsents = {
  preInformationAcceptedAt: string;
  distanceSalesAcceptedAt: string;
  returnPolicyAcceptedAt: string;
};

export function toStoredRegistrationConsents(
  consents: RegistrationConsents,
): StoredRegistrationConsents {
  const now = new Date().toISOString();
  return {
    termsAcceptedAt: now,
    kvkkReadAt: now,
    marketingAccepted: consents.marketingAccepted,
    marketingAcceptedAt: consents.marketingAccepted ? now : undefined,
  };
}

export function toStoredCheckoutConsents(_consents: CheckoutConsents): StoredCheckoutConsents {
  const now = new Date().toISOString();
  return {
    preInformationAcceptedAt: now,
    distanceSalesAcceptedAt: now,
    returnPolicyAcceptedAt: now,
  };
}
